import type { AppModule } from '@shared/presentation/router/composition.js';
import { appShellModule } from './app-shell/module.js';
import { errorsModule } from './errors/module.js';
import { homeModule } from './home/module.js';

/**
 * `platform` context: what holds the rest up — shell, home and errors.
 */
export const platformModules: AppModule[] = [appShellModule, homeModule, errorsModule];
